// extracted by mini-css-extract-plugin
export default {"container_menu":"Menu_container_menu__+wET6","list_menu":"Menu_list_menu__1P2Lz","img_logo":"Menu_img_logo__BtWI8","body_left":"Menu_body_left__avbrO"};